var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfocomponent = function SvgInfocomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667 9C.667 4.4 4.4.667 9 .667S17.333 4.4 17.333 9 13.6 17.333 9 17.333A8.336 8.336 0 0 1 .667 9Zm9.166-.834v5H8.166v-5h1.667ZM9 15.666A6.676 6.676 0 0 1 2.333 9 6.676 6.676 0 0 1 9 2.333 6.676 6.676 0 0 1 15.666 9 6.676 6.676 0 0 1 9 15.666Zm.833-10.833V6.5H8.166V4.833h1.667Z",
    fill: "current"
  })));
};
export default SvgInfocomponent;